{
  "moreActions": "Altre azioni",
  "unavailable": "Non disponibile, espandi per i dettagli"
}
